<template>
	<main-page></main-page>
</template>

<script>
import MainPage from './pages/Chouette.vue'

export default {
	name: 'App',
	components: {
		MainPage
	},

}

</script>

